/**
 * The bank transfer instructions shown on the Payments page.
 *
 * The backend exposes no bank-details endpoint by design, so the client owns
 * them. They are not a secret — the same values are printed on invoices.
 */
export type BankTransferDetails = {
  accountHolder: string;
  rib: string;
  swift: string;
  /** Only needed for transfers sent from outside Morocco. */
  iban: string;
};

export const BANK_TRANSFER_DETAILS: BankTransferDetails = {
  accountHolder: "VASTTECH SARL AU",
  rib: "007341000438200000049040",
  swift: "BCMAMAMC",
  iban: "MA64 007 341 0004382000000490 40",
};

/**
 * What the restaurateur should put in the transfer's reference field, so ops
 * can match a line on the bank statement back to a restaurant. Derived on the
 * client only: it is never sent, and the backend does not know about it.
 */
export const buildTransferReference = (
  restaurantName: string,
  restaurantId: string,
): string => {
  const shortId = restaurantId.slice(0, 8).toUpperCase();
  const name = restaurantName.trim().toUpperCase().replace(/\s+/g, "-");
  return name ? `${name}-${shortId}` : shortId;
};
